// import { Exercise, SetExercise, ProgramSession, ProgramSessionSet, Session } from '@api/entities';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { stat } from 'fs';
import sessionStorage from 'redux-persist/lib/storage';
import { ContextEnum } from 'src/_shared/enums/context.enum';
import { DashboardSessionSummary, Exercise, ProgramSession, ProgramSessionSet, Session, SetExercise } from 'src/api/entities';
// import { ContextEnum } from '@enums/context.enum';

// export interface SelectableWorkoutGroup {
//     label: string;
//     value: string;
// }

export interface WorkoutSessionCreateUpdate {
    selectedWorkout: Session;
    sessionDate: string;
}
export interface ProgramSessionSetExerciseCreateUpdate {
    uuid: string;
    name: string;
    group: string;
}

export interface WorkoutSessionSetCreatUpdate {
    exercise: SetExercise;
    uuid?: string;
    weight?: string;
    reps?: string;
    rest?: string;
}

// export interface WorkoutSessionCreateUpdate {
//     name: string;
//     sets: WorkoutSessionSetCreatUpdate[]
// }

export interface WorkoutSessionState {
    // workoutSessionCreateUpdate: WorkoutSessionCreateUpdate;
    selectedGroup: string;
    programSessionSetCreateUpdate: WorkoutSessionSetCreatUpdate;
    context: ContextEnum;
    workoutSession: ProgramSession;
    workoutSessions: ProgramSession[];
    customerSessions: ProgramSession[];
    availableWorkouts: Session[];
    workoutSessionCreateUpdate: WorkoutSessionCreateUpdate;
    workoutSessionSets: ProgramSessionSet[];
    sessionSummary: DashboardSessionSummary;
    workoutSummary: DashboardSessionSummary;
}

// const initialWorkoutSessionCreateUpdate: WorkoutSessionCreateUpdate = {
//     name: "",
//     sets: []
// };

const initialState: WorkoutSessionState = {
    programSessionSetCreateUpdate: {
        exercise: {},
    },
    workoutSession: {},
    // workoutSessionCreateUpdate: initialWorkoutSessionCreateUpdate,
    workoutSessions: [],
    customerSessions: [],
    context: ContextEnum.CREATE,
    selectedGroup: '',
    workoutSessionSets: [],
    availableWorkouts: [],
    workoutSessionCreateUpdate: {
        selectedWorkout: {},
        sessionDate: ''
    },
    sessionSummary: {
        exerciseSets: [],
        muscleGroupSets: [],
    },
    workoutSummary: {
        exerciseSets: [],
        muscleGroupSets: [],
    },
};

export const workoutSessionPersistedConfig = {
    key: 'workoutSession',
    storage: sessionStorage,
    whitelist: ['workoutSessionCreateUpdate', 'customerSessions', 'workoutSession', 'workoutSummary', 'availableWorkouts', 'workoutSessions', 'context', 'selectedGroup', 'programSessionSetCreateUpdate'],
};

export const workoutSessionSlice = createSlice({
    name: 'workoutSession',
    initialState: initialState,
    reducers: {
        setWorkoutExercise(state, action: PayloadAction<{ value: Exercise }>) {
            state.programSessionSetCreateUpdate.exercise = {
                group: action.payload.value.group,
                name: action.payload.value.name,
                uuid: action.payload.value.uuid,
            };
        },
        setWorkoutSetFormValue(state, action: PayloadAction<{ key: keyof WorkoutSessionSetCreatUpdate; value: string }>) {
            state.programSessionSetCreateUpdate[action.payload.key] = action.payload.value;
        },
        setSessionSummary(state, action: PayloadAction<{ response: DashboardSessionSummary }>) {
            state.sessionSummary = action.payload.response;
        },
        resetSessionSummary(state) {
            state.sessionSummary = initialState.sessionSummary;
        },
        setWorkoutSummary(state, action: PayloadAction<{ response: DashboardSessionSummary }>) {
            state.workoutSummary = action.payload.response;
        },
        resetWorkoutSummary(state) {
            state.workoutSummary = initialState.workoutSummary;
        },
        setWorkoutSessionSetItems(state, action: PayloadAction<{ sets: ProgramSessionSet[] }>) {
            state.workoutSessionSets = action.payload.sets;
        },
        setWorkoutSessionItems(state, action: PayloadAction<{ value: ProgramSession[] }>) {
            state.workoutSessions = action.payload.value;
            state.workoutSessions = state.workoutSessions.sort((a, b) => new Date(b.sessionDate!).getTime() - new Date(a.sessionDate!).getTime())
        },
        setCustomerSessionItems(state, action: PayloadAction<{ value: ProgramSession[] }>) {
            state.customerSessions = action.payload.value;
        },
        setWorkoutSessionItem(state, action: PayloadAction<{ response: ProgramSession }>) {
            state.workoutSession = action.payload.response;
        },
        setAvailableWorkoutItems(state, action: PayloadAction<{ response: Session[] }>) {
            state.availableWorkouts = action.payload.response;
        },
        setSelectedWorkoutItem(state, action: PayloadAction<{ value: Session }>) {
            state.workoutSessionCreateUpdate.selectedWorkout = action.payload.value;
        },
        setSelectedWorkoutSessionDate(state, action: PayloadAction<{ value: string }>) {
            console.log(action.payload.value)
            state.workoutSessionCreateUpdate.sessionDate = action.payload.value;
        },
        resetWorkoutSessionCreateUpdate(state) {
            state.workoutSessionCreateUpdate = initialState.workoutSessionCreateUpdate;
        },
        resetAvailableWorkoutItems(state) {
            state.availableWorkouts = initialState.availableWorkouts;
        },
        resetWorkoutCreateUpdate(state) {
            state.workoutSessionCreateUpdate = initialState.workoutSessionCreateUpdate;
        },
    },
});

export const {
    setWorkoutSetFormValue,
    setWorkoutExercise,
    resetWorkoutCreateUpdate,
    setWorkoutSummary,
    resetWorkoutSummary,
    setSessionSummary,
    resetSessionSummary,
    setWorkoutSessionItems,
    setWorkoutSessionSetItems,
    setSelectedWorkoutSessionDate,
    setWorkoutSessionItem,
    setSelectedWorkoutItem,
    setCustomerSessionItems,
    setAvailableWorkoutItems,
    resetWorkoutSessionCreateUpdate,
} = workoutSessionSlice.actions;

export const workoutSessionReducer = workoutSessionSlice.reducer;
